import Body from "../components/layout/Body";
import FileList from "../components/FileList";
import FolderListingSidebar from "../components/layout/Sidebar/FolderListingSidebar";
import { useNavigate, useParams } from "react-router-dom";
import useApiHook from "../hooks/useApiHook";
import { useEffect, useMemo } from "react";
import { useFolderRefresh } from "../store/modal-context";

const FolderPage = () => {
    const { folderId } = useParams();
    const navigate = useNavigate();
    const { response, makeRequest, error } = useApiHook();
    const { foldersVersion } = useFolderRefresh();

    useEffect(() => {
        if (!folderId || folderId === 'noFolder') {
            return;
        }

        makeRequest(`/folder/${folderId}`);
    }, [folderId, foldersVersion, makeRequest]);

    useEffect(() => {
        if (folderId && folderId !== 'noFolder' && error) {
            navigate('/dashboard');
        }
    }, [error, folderId, navigate]);

    const pageTitle = useMemo(() => {
        if (folderId === 'noFolder') {
            return 'Senza cartella';
        }

        return response?.data?.name || 'Cartella';
    }, [folderId, response]);

    return (
        <Body mainElement={<FileList folderId={folderId} scope={folderId === 'noFolder' ? 'root' : null} title={pageTitle} currentFolderName={response?.data?.name || null} />} sideBar={<FolderListingSidebar />} />
    );
};

export default FolderPage;
